module.exports = __webpack_public_path__ + "static/media/PDF.ab3c2b2f.svg";